import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { DatePicker } from '@mantine/dates';
import { Popover } from '@mantine/core';
import AttachIcon from '../../../assets/icons/AttachIcon';
import CalenderIcon from '../../../assets/icons/CalenderIcon';
import TextButton from '../../common/TextButton/TextButton';
import InputComponent from '../../common/InputComponent/InputComponent';
import { dayjs } from '../../../utils/dayjs-utils';
import { Spacer } from '../../common';
import { useFormValidation } from '../../../utils/useFormValidation';
import { logPostLinkSchema } from '../../../utils/validations';
import { addLogPost } from '../../../services/inbound.service';
import AddLogPostBottomComponent from './AddLogPostBottomComponent';

interface AddLinkLog {
  postedDate: Date | null;
  postUrl: string;
}

interface Props {
  onClose: () => any;
  refetchLogPosts: () => any;
  creatorDetails: Record<any, any>;
}

function AddLogPostLink({ onClose, creatorDetails, refetchLogPosts }: Props) {
  const [formData, setFormData] = useState<AddLinkLog>({ postedDate: new Date(), postUrl: '' });
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
  const [submittingForm, setSubmittingForm] = useState(false);

  const { validate, errors, setErrors } = useFormValidation<AddLinkLog>(logPostLinkSchema);

  const onFormSubmit = async () => {
    if (submittingForm) return;

    const isValid = validate(formData);
    if (!isValid) return;
    setSubmittingForm(true);
    const res = await addLogPost({ ...formData, influencerId: creatorDetails._id });

    if (res.status) {
      refetchLogPosts();
      toast.success('Post logged successfully.');
      onClose();
    } else {
      toast.error('Error logging post.');
    }
    setSubmittingForm(false);
  };

  return (
    <div>
      <InputComponent
        disabled={submittingForm}
        left={<AttachIcon />}
        label="Link to your Content"
        placeholder="Paste link here...."
        value={formData.postUrl}
        onChange={(v) => {
          setFormData((p) => ({ ...p, postUrl: v }));
          setErrors({});
        }}
        error={errors.postUrl}
      />
      <Spacer spacing="16px" />
      <Popover opened={isDatePickerOpen} onChange={setIsDatePickerOpen} position="top-end" offset={-26}>
        <Popover.Target>
          <InputComponent
            disabled={submittingForm}
            readonly
            left={<CalenderIcon />}
            right={<TextButton text="Change" onClick={() => setIsDatePickerOpen((v) => !v)} />}
            label="Posted Date"
            value={dayjs(formData.postedDate).format('DD/MM/YYYY')}
            onChange={() => {}}
            error={errors.postedDate}
          />
        </Popover.Target>
        <Popover.Dropdown>
          <DatePicker
            maxDate={new Date()}
            value={formData.postedDate}
            onChange={(v) => setFormData((p) => ({ ...p, postedDate: v }))}
          />
        </Popover.Dropdown>
      </Popover>
      <Spacer spacing="24px" />
      <AddLogPostBottomComponent isLoading={submittingForm} onClose={onClose} onSubmit={onFormSubmit} />
    </div>
  );
}

export default AddLogPostLink;
